import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class MapsService {
 datosConsulta:any[]=[]
  constructor(private http: HttpClient) {
   
   }

   async consulta(direccion){
      var lugares
      
   

        return this.http.get('https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDpdxJabo9anY2K_UCDDFapjrV5a3RC7nM&address='+direccion)
         

      
    
   }
  

   

}
